import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/layout/Layout";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

// Demo Pages
import ValetDemo from "./pages/demos/ValetDemo";
import HandwerkerDemo from "./pages/demos/HandwerkerDemo";
import FitLifeDemo from "./pages/demos/FitLifeDemo";
import RestaurantDemo from "./pages/demos/RestaurantDemo";
import ImmobilienDemo from "./pages/demos/ImmobilienDemo";
import MedCareDemo from "./pages/demos/MedCareDemo";
import BeautyDemo from "./pages/demos/BeautyDemo";
import CleaningDemo from "./pages/demos/CleaningDemo";
import TaxDemo from "./pages/demos/TaxDemo";

// Service Detail Pages
import Webseiten from "./pages/Webseiten";
import WebApps from "./pages/WebApps";
import ECommerce from "./pages/ECommerce";
import PWA from "./pages/PWA";
import UeberUns from "./pages/UeberUns";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Demo pages without layout */}
          <Route path="/demo/valet" element={<ValetDemo />} />
          <Route path="/demo/handwerker" element={<HandwerkerDemo />} />
          <Route path="/demo/fitlife" element={<FitLifeDemo />} />
          <Route path="/demo/restaurant" element={<RestaurantDemo />} />
          <Route path="/demo/immobilien" element={<ImmobilienDemo />} />
          <Route path="/demo/medcare" element={<MedCareDemo />} />
          <Route path="/demo/beauty" element={<BeautyDemo />} />
          <Route path="/demo/cleaning" element={<CleaningDemo />} />
          <Route path="/demo/tax" element={<TaxDemo />} />
          
          {/* Admin pages without layout */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Admin />} />
          
          {/* Main pages with layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/leistungen" element={<Services />} />
                <Route path="/preise" element={<Pricing />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/kontakt" element={<Contact />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/agb" element={<AGB />} />
                <Route path="/webseiten" element={<Webseiten />} />
                <Route path="/web-apps" element={<WebApps />} />
                <Route path="/e-commerce" element={<ECommerce />} />
                <Route path="/pwa" element={<PWA />} />
                <Route path="/ueber-uns" element={<UeberUns />} />
              </Routes>
            </Layout>
          } />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
